import { combineReducers } from "redux";

import { ACTION } from "./constants";

let initialState = {
  ProductSolutionReducer: {},
  allGoals: {
    apiLoaded: false,
  },
  goalsQuestion: {
    apiLoaded: false,
  },
  kycVerificationData: {
    apiLoaded: false,
  },
  riskQuestion: {
    apiLoaded: false,
  },
  riskAppetite: {
    apiLoaded: false,
  },
  basket: {
    apiLoaded: false,
  },
  riskAppetitesList: {
    apiLoaded: false,
  },
  allBaskets: {
    apiLoaded: false,
  },
  savePreLoginResponse: {
    apiLoaded: false,
  },
  getBasketSchemes: {
    apiLoaded: false,
  },
  otpVerificationData: {
    apiLoaded: false,
  },
  goalSuggestion: {
    apiLoaded: false,
  },
  forceLogout: {
    apiLoaded: false,
  },
};

function ProductSolutionReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION.GET_ALL_FUNDS_PRODUCT_LIST:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, productList: action.data },
      };
    case ACTION.GET_ALL_FUNDS_PRODUCT_FILTERS:
      return {
        ...state,
        productAllFund: {
          ...state.productAllFund,
          productFilters: action.data,
        },
      };
    case ACTION.GET_SINGLE_FUND_DETAILS:
      return {
        ...state,
        productAllFund: {
          ...state.productAllFund,
          productOverview: action.data,
        },
      };
    case ACTION.GET_SINGLE_FUND_NAV:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, productNAV: action.data },
      };
    case ACTION.GET_NFO_LIST:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, productNFO: action.data },
      };
    case ACTION.POST_COMPARE_LIST:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, compareList: action.data },
      };
    case ACTION.POST_COMPARE_LIST_DUBLICATE:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, compareList: action.data },
      };
    case ACTION.POST_COMPARE_FUNDS:
      return {
        ...state,
        productAllFund: {
          ...state.productAllFund,
          compareFundList: action.data,
        },
      };
    case ACTION.POST_NAV_OVERVIEW:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, navOverview: action.data },
      };
    case "POST_SMALL_CASE":
      return {
        ...state,
        productAllFund: {
          ...state.productAllFund,
          txnId: action.data.transactionId,
        },
      };
    case ACTION.GET_NFO_OVERVIEW:
      return {
        ...state,
        productAllFund: {
          ...state.productAllFund,
          nfoOverviewpage: action.data,
        },
      };
    case ACTION.GET_INDEX_FUND_LIST:
      return {
        ...state,
        productIndexFundData: action.data,
      };
    case ACTION.INDEX_SUBSCRIBE:
      return { ...state, indexSubscribe: action.data };
    case ACTION.CLEAN_INDEX_FUND_CONTENT:
      return {
        ...state,
        productAllFund: { ...state.productAllFund, productList: {} },
      };
    case ACTION.SMALL_CASE_TOKEN_HIDE:
      return {
        ...state,
        productAllFund: {
          ...state.productAllFund,
          smallCaseTodenData: action.data,
        },
      };
    //etf api
    case ACTION.GET_ETF:
      return { ...state, etfList: action.data };
    case ACTION.GET_ETF_FUNDS:
      return { ...state, etfFunds: action.data };
    case ACTION.GET_ETF_FUNDS_LIST:
      return { ...state, etfFundList: action.data };
    case ACTION.POST_ETF_SUBSCRIBE:
      return { ...state, etfSubscribeSuccess: action.data };
    case ACTION.GET_SCHEME_CONTENT_SCHEME:
      return { ...state, schemeDetails: action.data };
    case ACTION.POST_SUBSCRIBE_PRODUCT:
      return { ...state, subscribeResult: action.data };
    case ACTION.CLEAR_SUBSCRIBE_RESULT:
      return { ...state, subscribeResult: null };
    // investment basket
    case ACTION.GET_GOALS_CONTENT:
      return { ...state, allGoals: { ...action.data, apiLoaded: true } };

    case ACTION.GET_GOAL_QUESTION:
      return { ...state, goalsQuestion: { ...action.data, apiLoaded: true } };

    case ACTION.GET_GOAL_SUGGESTION:
      return { ...state, goalSuggestion: { ...action.data, apiLoaded: true } };

    case ACTION.VERIFY_PAN:
      return { ...state, panVerification: { ...action.data, apiLoaded: true } };

    case ACTION.VERIFY_KYC:
      return {
        ...state,
        kycVerificationData: { ...action.data, apiLoaded: true },
      };

    case ACTION.VERIFY_OTP:
      return {
        ...state,
        otpVerificationData: { ...action.data, apiLoaded: true },
      };

    case ACTION.RESEND_OTP:
      return { ...state, otpResendData: { ...action.data, apiLoaded: true } };

    case ACTION.CLEAN_GOALS_CONTENT:
      return { ...initialState };

    case ACTION.CLEAN_GOALS_QUESTIONS:
      return { ...state, goalsQuestion: { apiLoaded: false } };

    case ACTION.GET_RISK_QUESTION_ANS:
      return { ...state, riskQuestion: { ...action.data, apiLoaded: true } };

    case ACTION.EVALUATE_RISK_APPETITE:
      return { ...state, riskAppetite: { ...action.data, apiLoaded: true } };

    case ACTION.GET_BASKET_RECOMMENDATION:
      return { ...state, basket: { ...action.data, apiLoaded: true } };

    case ACTION.GET_RISK_APPETITES_LIST:
      return {
        ...state,
        riskAppetitesList: { ...action.data, apiLoaded: true },
      };

    case ACTION.GET_ALL_BASKETS:
      return { ...state, allBaskets: { ...action.data, apiLoaded: true } };
    case ACTION.BASKET_META:
      return { ...state, metaAllBaskets: { ...action.data } };

    case ACTION.SAVE_PRE_LOGIN_DATA:
      return {
        ...state,
        savePreLoginResponse: { ...action.data, apiLoaded: true },
      };
    case ACTION.VALIDATE_BASKET_SCHEMES:
      return {...state, getBasketSchemes:{...action.data, apiLoaded: true}}  
    case ACTION.CLEAN_RISK_CONTENT:
      return {
        ...state,
        riskQuestion: initialState.riskQuestion,
        riskAppetite: initialState.riskAppetite,
        riskAppetitesList: initialState.riskAppetitesList,
      };

    case ACTION.FORCE_LOGOUT:
      return { ...state, forceLogout: { ...action.data, apiLoaded: true } };

    case ACTION.CLEAN_AUTH_CONTENT:
      return { ...state, kycVerificationData: { apiLoaded: false } };
    case ACTION.POST_LINE_GRAPH:
      return { ...state, lineGraphData: action.data };
    default:
      return state;
  }
}

export default combineReducers({
  home: ProductSolutionReducer,
});
